export const getFormatedLabelFromOffset = (timezoneOffset: string) => {
  const offsetParts = timezoneOffset.split(':')
  const hours = offsetParts[0].replace(/(\+|-)(0+?)(\d{1,2})/, '$1$3')
  const minutes = offsetParts[1].replace('00', '')
  return `GMT${hours}${minutes ? `:${minutes}` : ''}`
}
